import * as ActionTypes from '../../actions/ActionTypes';
import CreateArticleRequestStatusRecord from '../../records/edit/CreateArticleRequestStatusRecord';
export default function createArticleRequestStatus(state = new CreateArticleRequestStatusRecord(), action) {
  switch (action.type) {
    case ActionTypes.CREATE_ARTICLE_PENDING:
      return state.merge({
        error: undefined,
        isCreating: true
      });
    case ActionTypes.CREATE_ARTICLE_SUCCESS:
      return state.merge({
        error: undefined,
        isCreating: false
      });
    case ActionTypes.CREATE_ARTICLE_ERROR:
      return state.merge({
        error: action.error,
        isCreating: false
      });
    default:
      return state;
  }
}